export default __webpack_public_path__ + "static/media/carro_esqueleto_01.321f0758.png";